/** IST period helpers for Management cockpit filters. */

export function istNow() {
  return new Date(new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
}

export function istDateStr(d) {
  const dt = new Date(d.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));
  return `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;
}

export const PERIOD_PRESETS = [
  { v: 'today', l: 'Today' },
  { v: 'week', l: 'This week' },
  { v: 'month', l: 'This month' },
  { v: '7', l: 'Last 7 days' },
  { v: '30', l: 'Last 30 days' },
  { v: '90', l: 'Last 90 days' },
  { v: '180', l: 'Last 6 months' },
  { v: '365', l: 'Last year' },
];

function startOfWeekMon(d) {
  const x = istNow();
  x.setTime(d.getTime());
  const day = x.getDay(); // 0 Sun
  const diff = day === 0 ? -6 : 1 - day;
  x.setDate(x.getDate() + diff);
  x.setHours(0, 0, 0, 0);
  return x;
}

/** Default period: this calendar month (1st → today IST). */
export function computeRange(preset) {
  const to = istNow();
  const from = istNow();
  const meta = PERIOD_PRESETS.find((p) => p.v === preset) || PERIOD_PRESETS[2];

  if (preset === 'today') {
    return { from: istDateStr(to), to: istDateStr(to), label: meta.l };
  }
  if (preset === 'week') {
    return { from: istDateStr(startOfWeekMon(to)), to: istDateStr(to), label: meta.l };
  }
  if (preset === 'month') {
    from.setDate(1);
    return { from: istDateStr(from), to: istDateStr(to), label: meta.l };
  }
  const days = Number(preset);
  if (Number.isFinite(days) && days > 0) {
    from.setDate(from.getDate() - days);
    return { from: istDateStr(from), to: istDateStr(to), label: meta.l };
  }
  from.setDate(1);
  return { from: istDateStr(from), to: istDateStr(to), label: 'This month' };
}

export function buildMgmtQuery({ from, to, doctorId, specialisation }) {
  const params = new URLSearchParams({ from, to });
  if (doctorId) params.set('doctor_id', doctorId);
  if (specialisation) params.set('specialisation', specialisation);
  return params.toString();
}
